function TableDataRegulationBootstrap({ data, savedColumnLabel = 'Guardado' }) {

    const columns = [
        { header: 'Nro', key: 'rowNumber', width: 23, visible: true },
        { header: 'Mensaje', key: 'stepsErrors', width: 23, visible: true },
        { header: 'Valido', key: 'isValid', width: 23, visible: true },
        { header: savedColumnLabel, key: 'isSaved', width: 23, visible: true },
        { header: 'Id', key: 'registerId', width: 23, visible: true },
        { header: 'Codigo', key: 'code', width: 11, visible: true },
        { header: 'Nombre', key: 'name', width: 80, visible: true },
    ];

    return (
        <div>
            <div className="text-start">
                <strong>Data de Tecnología importada:</strong>
            </div>
            <div className="table-responsive">
                <table className="table table-bordered">
                    <thead>
                        <tr className=''>
                            {data && data.length > 0 && columns && columns.length > 0 && (
                                columns.map((item, index) => {
                                    return (
                                        <th className=''>{item.header}</th>
                                    )
                                })
                            )}
                        </tr>
                    </thead>
                    <tbody>

                        {/* Start Table Body Columns */}
                        {data && data.length > 0 && (
                            data.map((item, index) => {
                                return (
                                    <tr key={index} className=''>

                                        <td className="list-table-cell-50"> {item.rowNumber} </td>
                                        <td className="list-table-cell-400"> {item.stepsErrors} </td>
                                        <td className="list-table-cell-50"> {item.isValid ? "Si" : "No"} </td>
                                        <td className="list-table-cell-50"> {item.isSaved ? "Si" : "No"} </td>
                                        <td className="list-table-cell-100"> {item.registerId && item.registerId !== -1 ? item.registerId : "—"} </td>
                                        <td className="list-table-cell-150"> {item.values.code} </td>
                                        <td className="list-table-cell-400"> {item.values.name} </td>
                                    </tr>
                                )
                            })
                        )}
                        {/* End Table Body Columns */}

                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default TableDataRegulationBootstrap